import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=da7e0126&scoped=true&"
import script from "./Round.vue?vue&type=script&lang=ts&"
export * from "./Round.vue?vue&type=script&lang=ts&"
import style0 from "./Round.vue?vue&type=style&index=0&id=da7e0126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7e0126",
  null
  
)

export default component.exports